export default "__VITE_ASSET__a23317fc__"